export default {
  setUserInfo({commit}, data) {
    commit('setUserInfo', data)
  },
  setToken({commit}, data) {
    commit('setToken', data)
  },
  setCode({commit}, data) {
    commit('setCode', data)
  },
  setSign({commit}, data) {
    commit('setSign', data)
  },
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js